// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from TagsInline.module.scss  */
.TagsInline-module-Root_3j4 {
  position: relative;
  overflow: scroll;
  flex-wrap: nowrap;
  width: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none; }

.TagsInline-module-Root_3j4::-webkit-scrollbar {
  display: none; }

.TagsInline-module-ScrollWrapper_3Vv {
  display: inline-flex;
  gap: 8px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/TagsInline/TagsInline.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,wBAAwB;EACxB,qBAAqB,EAAE;;AAEzB;EACE,aAAa,EAAE;;AAEjB;EACE,oBAAoB;EACpB,QAAQ,EAAE","sourcesContent":["/*  imported from TagsInline.module.scss  */\n.TagsInline-module-Root_3j4 {\n  position: relative;\n  overflow: scroll;\n  flex-wrap: nowrap;\n  width: 100%;\n  -ms-overflow-style: none;\n  scrollbar-width: none; }\n\n.TagsInline-module-Root_3j4::-webkit-scrollbar {\n  display: none; }\n\n.TagsInline-module-ScrollWrapper_3Vv {\n  display: inline-flex;\n  gap: 8px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
